import { Directive, Input, EventEmitter, ElementRef, Renderer, Inject} from '@angular/core';

@Directive({
  selector: '[focusOn]'
})
export class FocusDirective {
	@Input('focusOn') focusEvent: EventEmitter<boolean>;
  constructor(@Inject(ElementRef) private element: ElementRef, private renderer: Renderer) { }


  ngOnInit() {
    this.focusEvent.subscribe(event => {
      this.renderer.invokeElementMethod(this.element.nativeElement, 'focusOn', []);
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/directives/focus.directive.ts